import type { AxiosRequestConfig } from "axios";
import { apiClient } from "queries/constants";
import { isDev } from "ui/lib/helpers";
import { Team, TeamResponse, TeamsResponse } from "./types";

export const listTeams = async (): Promise<Team[]> => {
  const { data } = await apiClient.get<{ teams: Team[] }>(
    `/v1/listTeams${isDev ? "?authUserID=arnold" : ""}`
  );

  return data.teams;
};
export const getTeamsData = async (): Promise<TeamsResponse> => {
  const { data } = await apiClient.get<TeamsResponse>(
    `/v1/listTeams${isDev ? "?authUserID=arnold" : ""}`
  );

  return data;
};

export const getTeam =
  (teamID = "") =>
  async () => {
    const response = await apiClient.get<TeamResponse>(
      `/v1/getTeam?teamID=` + teamID
    );

    return response.data;
  };

export const setMemberTeam = async (
  teamID: string,
  userID: string,
  config?: AxiosRequestConfig
) => {
  const response = await apiClient.post<{
    teamWasChanged: boolean;
    isFirstTeam: boolean;
    membershipStatus: string;
    createdIntroTrialPeriodID: string | null;
    compTeamSwitchRemainCount: number;
    freeSwitchTeamIDs: string[];
    isRequiredToCompleteWelcomeWorkout: boolean;
  }>(
    `/v1/setUserTeam`,
    { userID, teamID },
    config
  );

  return response.data;
};
